import { render, staticRenderFns } from "./SearchResultContainer.vue?vue&type=template&id=e1faef32&scoped=true"
import script from "./SearchResultContainer.vue?vue&type=script&lang=ts"
export * from "./SearchResultContainer.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultContainer.vue?vue&type=style&index=0&id=e1faef32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1faef32",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-search-result.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FSearchResultContainer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports